<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'under-salary.shops' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeIds" [multiple]="true" (selectChange)="getTypeFilter()"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'under-salary.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="getTypeFilter()"></hx-date-range-select>
            </div>

            <div class="filter">
              <div class="form-group" style="margin: 0.7rem 0;">
                <label class="m-checkbox m-checkbox--state-primary m--margin-left-10">
                  <input type="checkbox" [(ngModel)]="params.debtor" (change)="getTypeFilter()">
                  {{ 'under-salary.debtors' | transloco }}
                  <span></span>
                </label>
              </div>
            </div>
          </div>

          <button *ngIf="selectedItemCount > 0 && params.debtor" (click)="closeDebtList()" [disabled]="isLoading.close"
                  [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.close}"
                  type="button" class="btn btn-outline-info m-btn m-btn--icon m--margin-top-15">
            <i class="la la-money"></i>{{ 'under-salary.debt' | transloco }}
          </button>

          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30" *ngIf="list.length && !isLoading.list">
            <table class="m-datatable__table">
              <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell" style="width: 10px">
                    <label class="m-checkbox m-checkbox--text" (change)="checkAll()">
                      <input type="checkbox" [(ngModel)]="isAll">
                      <span></span>
                    </label>
                  </th>
                  <th class="m-datatable__cell ">
                    <span>#</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'under-salary.table.head.name' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell text-right">
                    <span>{{ 'under-salary.table.head.debt' | transloco }}, {{ currencySymbol }}</span>
                  </th>
                  <th class="m-datatable__cell text-right">
                    <span>{{ 'under-salary.table.head.writeOff' | transloco }}, {{ currencySymbol }}</span>
                  </th>
                  <th class="m-datatable__cell" *ngIf="selectedItemCount === 0 && params.debtor">
                  </th>
                </tr>
              </thead>
              <tbody class="m-datatable__body">
                <tr *ngFor="let even = even; let i = index; let item of list" class="m-datatable__row"
                [ngClass]="{ 'm-datatable__row--even': even }">
                  <td class="m-datatable__cell">
                    <label class="m-checkbox" (change)="toggleDebt(item)">
                      <input type="checkbox" [name]="'checkbox_' + item.user.id" [checked]="item.selected">
                      <span></span>
                    </label>
                  </td>
                  <td style="width: 40px;" class="m-datatable__cell">{{ i + 1 }}</td>
                  <td class="m-datatable__cell">
                    {{ item.user?.fullname }}
                    <strong *ngIf="!item.user">{{ 'under-salary.table.head.total' | transloco }}</strong>
                  </td>
                  <td class="m-datatable__cell text-nowrap text-right" style="min-width: 100px; width: 15%;">
                    <a *ngIf="item.user" [title]="item.user?.fullname" [routerLink]="['full']" [queryParams]="{employee: item.user.id, dateFrom: params.date?.from, dateTo: params.date?.to, underSalary: true, isDebtPage: true }">
                      {{ item.debtTotal }}
                    </a>
                  </td>
                  <td class="m-datatable__cell text-nowrap text-right" style="min-width: 100px; width: 15%;">
                    <a *ngIf="item.user && item.discardTotal > 0" [title]="item.user?.fullname" [routerLink]="['discards']" [queryParams]="{userId: item.user.id, userFullname: item.user.fullname, dateFrom: params.date?.from, dateTo: params.date?.to }">
                      {{ item.discardTotal }}
                    </a>
                  </td>
                  <td class="m-datatable__cell text-nowrap text-right" style="width: 50px;" *ngIf="selectedItemCount === 0 && params.debtor">
                    <button (click)="closeDebtItem(item)"
                            [disabled]="isLoading.close"
                            [ngClass]="{'m-loader m-loader--light m-loader--primary m-loader--left': isLoading.close}"
                            type="button"
                            class="btn btn-outline-info m-btn m-btn--icon" [ngbTooltip]="'under-salary.debt' | transloco">
                      <span>
                        <i class="la la-money"></i>
                        <span>{{ 'under-salary.debt' | transloco }}</span>
                      </span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
        </div>
      </div>
    </div>
  </div>
</div>
